import { Theme, makeStyles } from '@material-ui/core';

type Props = {
  isNavigation?: boolean;
};

export const useStyles = makeStyles<Theme, Props>(() => ({
  buttonRoot: {
    padding: '4px 8px',
    margin: '0px -8px',
  },
  contentRoot: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,

    '&.baseline': {
      alignItems: 'baseline',
    },
  },
  title: {
    lineHeight: 1,
    width: ({ isNavigation }) => (isNavigation ? 190 : 'auto'),
  },
}));
